const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/wrapping-machines`,
    saveSpeedTable: `${API_URL}/wrapping-machine/save-speed-table`,
    information: `${API_URL}/wrapping-machine/information`
};

export default apiUrls;
